import { Component, ErrorInfo, ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null, errorInfo: null };

  static getDerivedStateFromError(error: Error) {
    return { error, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error, errorInfo });
    // You can also log the error to an error reporting service here
    console.error("Uncaught error in React tree:", error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground p-6">
          <h1 className="text-3xl font-bold mb-4">Something went wrong</h1>
          <p className="mb-4">An error occurred while rendering the app. See the console for details.</p>
          <div className="w-full max-w-2xl bg-card border border-border rounded-xl p-4 overflow-auto">
            <pre className="whitespace-pre-wrap text-sm">{this.state.error.toString()}</pre>
            {this.state.errorInfo && (
              <pre className="whitespace-pre-wrap text-xs text-muted-foreground mt-3">
                {this.state.errorInfo.componentStack}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
